import React, { useEffect, useState } from 'react';
import './styles.scss';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import EpAvatar from '../EpAvatar';
import EpUserMenu from '../EpUserMenu';
// import { signoutRedirect } from '../../services/authService';

const EpAvatarDropdown = ({ avatarMenuId, avatarContainerId }) => {
  // const handleSignOut = () => signoutRedirect();
  const user = useSelector(state => state.auth.user);
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');

  function getUserInitials() {
    if (user) {
      setUserName(user.given_name);
      setUserEmail(user.preferred_username);
    }
  }

  useEffect(() => {
    getUserInitials();
  }, [user]);

  return (
    <div className="dropdown navigation__dropdown" id={avatarContainerId}>
      <a
        href="/"
        className="dropdown-toggle navigation__dropdown-link"
        id={avatarMenuId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <EpAvatar />
      </a>
      <EpUserMenu userName={userName} userEmail={userEmail} id={avatarMenuId} />
    </div>
  );
};

export default EpAvatarDropdown;

EpAvatarDropdown.defaultProps = {
  avatarContainerId: '',
};

EpAvatarDropdown.propTypes = {
  avatarMenuId: PropTypes.string.isRequired,
  avatarContainerId: PropTypes.string,
};
